import Component from 'gia/Component'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import _each from 'lodash.foreach'
import VirtualScroll from 'virtual-scroll'
import stage from '../components/stage'

gsap.registerPlugin(ScrollTrigger);

class Projects extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element
    this.scrolling = false


    this.ref =  {
      text: null,
      scroller: null,
      project: [],
      images: []
    }

  }


  mount() {

    this.tl = gsap.timeline({});
    this.tl.pause()
    this.tl.to(this.ref.scroller, {y: "-=30", duration: .5, ease: "power4.out"});
    this.tl.to(this.ref.scroller, {y: "+=30", duration: .3, ease: "power4.out", onComplete: ()=>{

       this.vs.on(this.scroll, this)

       gsap.delayedCall(1, this.restart.bind(this));

     }});


    // var titles = gsap.utils.toArray(".section__title")
    // var spacers = gsap.utils.toArray(".section__spacer")
    this.total = this.ref.project.length
    this.index = 0
    this.active = 0
    this.next = 1
    this.resizeQue = this.resize.bind(this)
    stage.on("stage:resize", this.resizeQue);
    this.resize(stage)

    this.vs = new VirtualScroll({passive: true})

    gsap.delayedCall(1, ()=>{
      $(this.ref.text).addClass('loaded')
    })

    this.animations = []

    this.vs.on(this.scroll, this)

  }

  scroll(e){

    if(!this.scrolling){
      this.scrolling = true
      this.vs.off(this.scroll, this)
      this.nextProject(e.deltaY)
   }

  }

  restart(){
    this.scrolling = false
  }

  nextProject(dir){

    var test = 0
  //  console.log(dir);

    this.prev = Math.min(this.index, this.total) - 1

    if(dir < 0) {
        this.index++

        if(this.index >= this.total  ){
          this.index = this.total
        }

    }
    else if(dir > 0){
       this.index--

       if(this.index <= 0 ){
         this.index = 0
       }
    }

    this.active = Math.min(this.index, this.total) - 1

    this.prev >= 0 && $(this.ref.project[this.prev]).data('project').start(false)
    this.active >= 0 && $(this.ref.project[this.active]).data('project').start(true)

  // console.log(this.prev,this.active);

    this.body.toggleClass('has-projects', this.active > 0)
    if(this.prev == this.active ){
    //    console.log(test );
        test == 0 && this.tl.play(0)
        test = 1
    }
    else {
      test = 0
      gsap.to(this.ref.scroller, {
        duration:1.3 ,
        ease: 'expo.inOut',
        force3D: true,
        y: -this.index*this.h ,
        onComplete: ()=>{
           this.vs.on(this.scroll, this)
           this.scrolling = false
         }
      })
    }


  }


  resize(e){


    _each(this.ref.project, (el)=>{
      gsap.set(el, {height: e.h})
    })

    gsap.set(this.ref.text, {height: e.h})
    gsap.set(this.ref.scroller, {height: e.h * (this.total + 1)})
    // this.render(e)

    this.h = e.h

    gsap.to(this.ref.scroller, {
      duration:0.1 ,
      ease: 'linear',
      force3D: true,
      y: -this.index*this.h

    })
  }

  unmount() {

      stage.removeListener("stage:resize", this.resizeQue);
      this.vs.off(this.scroll, this)
      this.vs.destroy()
      this.vs = null
  }


}

module.exports = Projects
